<template>
  <Loader v-if="loader" />
  <ConfirmDialog group="client-contact-edit">
    <template #message="slotProps">
      <div class="contact-edit-confirmation">
        <div class="flex align-items-center">
          <i class="pi pi-exclamation-triangle mr-3" aria-hidden="true"></i>
          <span>{{ slotProps.message.message }}</span>
        </div>
        <div v-if="slotProps.message.duplicateContacts?.length" class="duplicate-contacts-list">
          <section v-for="duplicate in slotProps.message.duplicateContacts" :key="duplicate.id" class="duplicate-contact-section">
            <div class="duplicate-contact-title">
              <span class="duplicate-contact-dialog-hand" aria-hidden="true">&#128073;</span>
              <strong>Contatto esistente #{{ duplicate.id }}</strong>
            </div>
            <div>{{ contactAddress(duplicate) }}</div>
            <div>Email: {{ duplicate.email || '(vuota)' }}</div>
            <div>PEC: {{ duplicate.pec || '(vuota)' }}</div>
            <div>Cellulare: {{ duplicate.cell || '(vuoto)' }}</div>
          </section>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ContactImpactDialog
    v-model="contactDialog.visible"
    :header="contactDialog.header"
    :message="contactDialog.message"
    :changes="contactDialog.changes"
    :contact="contactDialog.contact"
    :contracts-header="contactDialog.contractsHeader"
    :confirmable="contactDialog.confirmable"
    @confirm="confirmContactImpact"
  />
  <SupplyRiepilogoSection
    v-if="data.item.id"
    :cliente-id="data.item.id"
    :cliente-nome="nomeCompletoCliente"
    :saldo-residuo="clienteSaldoResiduo"
    :supply-points="clienteSupplyPoints"
  />
  <prime-accordion v-model:activeIndex="activeAccordionTabs" :multiple="true">
    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Dettagli -</span>&nbsp;<span>{{ nomeCompletoCliente }}</span>
        <impersonate-button
          class="ml-auto"
          target-type="client"
          :target-id="data.item.id"
          :emails="impersonationEmails"
          :name="nomeCompletoCliente"
        />
      </template>

      <div v-if="data.item.id">
        <div class="formgrid grid">
          <div class="field col-12 md:col-4"><!--Ragione sociale-->
            <label for="ragsoc">Ragione Sociale</label>
            <prime-input-text
              id="ragsoc"
              v-model="data.item.info.ragsoc"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Nome-->
            <label for="nome">Nome</label>
            <prime-input-text
              id="nome"
              v-model="data.item.info.nome"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Cognome-->
            <label for="cognome">Cognome</label>
            <prime-input-text
              id="cognome"
              v-model="data.item.info.cognome"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Codice Fiscale-->
            <label for="codfis">Codice Fiscale</label>
            <prime-input-text
              id="codfis"
              v-model="data.item.info.codfis"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Partita Iva-->
            <label for="piva">Partita Iva</label>
            <prime-input-text
              id="piva"
              v-model="data.item.info.piva"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Score-->
            <label for="score">Score</label>
            <prime-input-text
              id="score"
              v-model="data.item.info.score"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Toponimo-->
            <label for="toponimo">Toponimo</label>
            <prime-input-text
              id="toponimo"
              v-model="data.item.info.toponimo"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Indirizzo-->
            <label for="indirizzo">Indirizzo</label>
            <prime-input-text
              id="indirizzo"
              v-model="data.item.info.indirizzo"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Civico-->
            <label for="civico">Civico</label>
            <prime-input-text
              id="civico"
              v-model="data.item.info.civico"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Cap-->
            <label for="cap">Cap</label>
            <prime-input-text
              id="cap"
              v-model="data.item.info.cap"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Comune-->
            <label for="cod_comune">Comune</label>
            <AutoComplete
              id="cod_comune"
              v-model="comuneInput"
              :suggestions="comuniFiltered"
              optionLabel="descrizione"
              :minLength="2"
              :disabled="!isInEdit"
              :forceSelection="true"
              placeholder="Cerca comune..."
              class="inputfield w-full"
              :inputClass="'w-full'"
              :inputStyle="{ width: '100%' }"
              @complete="searchComuni"
              @item-select="onSelectComune"
              @clear="onClearComune"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Email-->
            <label for="cap">Email</label>
            <prime-input-text
              id="email"
              v-model="data.item.info.email"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Telefono-->
            <label for="cap">Telefono</label>
            <prime-input-text
              id="telefono"
              v-model="data.item.info.telefono"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Cellulare-->
            <label for="cap">Cellulare</label>
            <prime-input-text
              id="cellulare"
              v-model="data.item.info.cellulare"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Note-->
            <label for="note">Note</label>
            <prime-textarea
              id="note"
              v-model="data.item.info.note"
              rows="3"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Categoria-->
            <label for="cod_type_category_client">Categoria</label>
            <prime-dropdown
              id="cod_type_category_client"
              v-model="data.item.info.cod_type_category_client"
              :options="data.tipiCategoriaCliente"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Tipologia Cliente-->
            <label for="cod_type_client">Tipologia</label>
            <prime-dropdown
              id="cod_type_client"
              v-model="data.item.info.cod_type_client"
              :options="data.tipiCliente"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Codice IVA-->
            <label for="codiceIva">Codice IVA</label>
            <prime-dropdown
              id="codiceIva"
              v-model="data.item.info.cod_codici_iva"
              :options="data.codiciIva"
              optionLabel="descrizione"
              optionValue="id"
              placeholder="Seleziona..."
              :filter="true"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3"><!--Codice Destinatario-->
            <label for="codiceDestinatario">Codice Destinatario</label>
            <prime-input-text
              id="codiceDestinatario"
              v-model="data.item.info.codiceDestinatario"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3"><!--Codice ATECO-->
            <label for="codiceAteco">Codice ATECO</label>
            <prime-input-text
              id="codiceAteco"
              v-model="data.item.info.codiceAteco"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3"><!--Cliente Tipo Doc-->
            <label for="type_doc">Cliente Tipo Doc.</label>
            <prime-input-text
              id="type_doc"
              v-model="data.item.info.type_doc"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Pregiudizievoli-->
            <label for="pregiudizi">Pregiudizievoli</label>
            <prime-input-text
              id="pregiudizi"
              v-model="data.item.info.pregiudizi"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4"><!--Ultimo Fatturato-->
            <label for="ultimo_fatturato">Ultimo Fatturato</label>
            <prime-input-text
              id="ultimo_fatturato"
              v-model="data.item.info.ultimofatturato"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3"><!--Nota Fattura-->
            <label for="note_fattura">Note Fattura</label>
            <prime-textarea
              id="note_fattura"
              v-model="data.item.info.note_fattura"
              rows="3"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3"><!--Nascondi scaduto-->
            <label for="">Nascondi Scaduto</label>
            <Checkbox
              v-model="data.item.info.nascondiscaduto"
              :disabled="!isInEdit"
              :binary="true"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3"><!--Nascondi Scaduto Anni precedenti-->
            <label for="">Nascondi Scaduto Anni precedenti</label>
            <Checkbox
              v-model="data.item.info.nascondiScadutoAnnoPrecedente"
              :disabled="!isInEdit"
              :binary="true"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3"><!--Sospendibile/Preavvisabile-->
            <label for="">Sospendibile/Preavvisabile</label>
            <Checkbox
              v-model="data.item.info.notificaPreavvisi"
              :true-value="1"
              :false-value="0"
              :disabled="!isInEdit || !sospendibilePreavvisabilePermesso"
              :binary="true"
              class="inputfield w-full"
            />
          </div>
        </div>

        <div class="grid p-jc-end">
          <div class="col-12 text-right" v-if="!isInEdit">
            <prime-button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success mr-2"
              @click="onEditInfo"
            />
          </div>

          <div class="col-12 text-right" v-if="isInEdit">
            <prime-button
              icon="pi pi-times"
              class="p-button-rounded p-button-danger mr-2"
              @click="onAbortInfoEdit"
            />
            <prime-button
              icon="pi pi-check"
              class="p-button-rounded p-button-success mr-2"
              @click="onUpdateInfo"
            />
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab v-if="data.item.id && !isClienteDomestico">
      <template v-if="data.item.id" #header>
        <span>Rappresentante - {{ rappresentante.name }}</span>
      </template>

      <div class="representative-contacts-section">
        <section class="representative-summary-card">
          <h5>Rappresentante</h5>
          <div class="representative-summary-grid">
            <div class="representative-summary-field">
              <span>Nome</span>
              <strong>{{ rappresentante.name || 'Non indicato' }}</strong>
            </div>
            <div class="representative-summary-field">
              <span>Codice fiscale</span>
              <strong>{{ rappresentante.codfis || 'Non indicato' }}</strong>
            </div>
            <div class="representative-summary-field">
              <span>Email</span>
              <strong>{{ rappresentante.email || 'Non indicata' }}</strong>
            </div>
            <div class="representative-summary-field">
              <span>PEC</span>
              <strong>{{ rappresentante.pec || 'Non indicata' }}</strong>
            </div>
          </div>
        </section>
      </div>
      <prime-accordion class="mt-3" @tab-open="loadStoricoCambiRappresentante">
        <prime-accordion-tab header="Storico cambi rappresentante">
          <StoricoCambioAnagrafica kind="rappresentante" :entries="storicoCambiRappresentante" :loading="storicoCambiRappresentanteLoading" :error="storicoCambiRappresentanteError" />
        </prime-accordion-tab>
      </prime-accordion>
    </prime-accordion-tab>

    <prime-accordion-tab header="Contatti">
      <div v-if="data.item.id" class="representative-contacts-section">
        <prime-data-table
          v-if="isClienteDomestico"
          :value="contactRows"
          v-model:editingRows="editingContactRows"
          editMode="row"
          dataKey="id"
          :rowClass="contactRowClass"
          @row-edit-save="onContactRowEditSave"
          @row-edit-init="onContactRowEditInit"
          @row-edit-cancel="onContactRowEditCancel"
          class="representative-contacts-table"
          responsiveLayout="scroll"
        >
          <prime-column v-if="!isContactRowEditing" field="id" header="ID" style="min-width: 10rem">
            <template #body="{ data }">
              <div class="contact-id-cell">
                <div class="contact-id-main">
                  <span v-if="isHighlightedDuplicate(data)" class="duplicate-contact-badge" aria-hidden="true">&#128073;</span>
                  <strong>#{{ data.id }}</strong>
                </div>
                <span v-if="data.duplicate_of" class="contact-duplicate-label">Duplicato di #{{ data.duplicate_of }}</span>
              </div>
            </template>
          </prime-column>
          <prime-column field="toponimo" header="Toponimo">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'toponimo')" v-tooltip.top="contactFieldError(data, 'toponimo')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.toponimo }}</span></div></template>
            <template #editor="{ data, field }"><prime-dropdown v-model="data[field]" :options="contactToponimi" optionLabel="name" optionValue="name" filter placeholder="Seleziona toponimo" /></template>
          </prime-column>
          <prime-column field="indirizzo" header="Indirizzo">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'indirizzo')" v-tooltip.top="contactFieldError(data, 'indirizzo')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.indirizzo }}</span></div></template>
            <template #editor="{ data, field }"><prime-input-text v-model="data[field]" /></template>
          </prime-column>
          <prime-column field="civico" header="Civico">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'civico')" v-tooltip.top="contactFieldError(data, 'civico')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.civico }}</span></div></template>
            <template #editor="{ data, field }"><prime-input-text v-model="data[field]" /></template>
          </prime-column>
          <prime-column field="cap" header="CAP">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'cap')" v-tooltip.top="contactFieldError(data, 'cap')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.cap }}</span></div></template>
            <template #editor="{ data, field }">
              <div v-if="contactCapSettings(data).isWildcard" class="multicap-editor"><span class="multicap-prefix">{{ contactCapSettings(data).prefix }}</span><prime-input-text :modelValue="contactCapSuffix(data)" maxlength="2" inputmode="numeric" class="multicap-suffix" @update:modelValue="updateMultiCapSuffix(data, $event)" /></div>
              <prime-input-text v-else v-model="data[field]" :disabled="contactCapSettings(data).isFixed" />
            </template>
          </prime-column>
          <prime-column field="comune" header="Comune" :sortable="true">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'comune')" v-tooltip.top="contactFieldError(data, 'comune')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.comune }}</span></div></template>
            <template #editor="{ data }"><prime-dropdown v-model="data.cod_comune" @change="onChangeComuneContact($event, data)" :options="contactComuni" optionLabel="name" optionValue="id" filter placeholder="Seleziona comune" /></template>
          </prime-column>
          <prime-column field="provincia" header="Provincia">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'provincia')" v-tooltip.top="contactFieldError(data, 'provincia')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.provincia }}</span></div></template>
          </prime-column>
          <prime-column field="email" header="Email">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'email')" v-tooltip.top="contactFieldError(data, 'email')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.email }}</span></div></template>
            <template #editor="{ data, field }"><prime-input-text v-model="data[field]" /></template>
          </prime-column>
          <prime-column field="pec" header="PEC">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'pec')" v-tooltip.top="contactFieldError(data, 'pec')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.pec }}</span></div></template>
            <template #editor="{ data, field }"><prime-input-text v-model="data[field]" /></template>
          </prime-column>
          <prime-column field="fax" header="Fax"><template #editor="{ data, field }"><prime-input-text v-model="data[field]" /></template></prime-column>
          <prime-column field="tel" header="Telefono"><template #editor="{ data, field }"><prime-input-text v-model="data[field]" /></template></prime-column>
          <prime-column field="cell" header="Cellulare">
            <template #body="{ data }"><div class="contact-field-cell"><i v-if="contactFieldError(data, 'cell')" v-tooltip.top="contactFieldError(data, 'cell')" class="pi pi-exclamation-triangle contact-validation-icon mr-2"></i><span>{{ data.cell }}</span></div></template>
            <template #editor="{ data, field }"><prime-input-text v-model="data[field]" /></template>
          </prime-column>
          <prime-column v-if="!isContactRowEditing" header="Associazioni" :exportable="false" style="width: 7rem" bodyStyle="text-align:center">
            <template #body="{ data }">
              <prime-button
                v-if="hasContactAssociations(data)"
                icon="pi pi-eye"
                class="p-button-rounded p-button-info"
                v-tooltip.top="`Contratti: ${data.numero_contratti ?? data.contratti?.length ?? 0} · Caricamenti: ${data.numero_caricamenti ?? data.caricamenti?.length ?? 0}`"
                aria-label="Mostra contratti e caricamenti associati"
                @click.stop="openContactAssociations(data)"
              />
            </template>
          </prime-column>
          <prime-column v-if="!isContactRowEditing" field="numero_contratti_attivi" header="Contratti attivi" style="width: 7rem" bodyStyle="text-align:center">
            <template #body="{ data }">{{ data.numero_contratti_attivi ?? 0 }}</template>
          </prime-column>
          <prime-column style="width: 8rem" bodyStyle="text-align:center">
            <template #body="{ editorInitCallback }"><prime-button icon="pi pi-pencil" class="p-button-rounded p-button-text" aria-label="Modifica contatto" @click="editorInitCallback" /></template>
            <template #editor="{ data, editorSaveCallback, editorCancelCallback }">
              <div class="flex justify-content-center gap-2">
                <span v-tooltip.top="{ value: contactRowSaveDisabledTooltip(data), disabled: !isContactRowSaveDisabled(data) }"><prime-button icon="pi pi-check" class="p-button-rounded p-button-text p-button-success" :disabled="isContactRowSaveDisabled(data)" aria-label="Salva modifiche contatto" @click="editorSaveCallback" /></span>
                <prime-button icon="pi pi-times" class="p-button-rounded p-button-text p-button-danger" aria-label="Annulla modifica contatto" @click="editorCancelCallback" />
              </div>
            </template>
          </prime-column>
        </prime-data-table>

        <prime-data-table
          v-else
          :value="contactRows"
          class="representative-contacts-table"
          responsiveLayout="scroll"
        >
          <prime-column field="id" header="ID" style="min-width: 7rem">
            <template #body="{ data }"><strong>#{{ data.id }}</strong></template>
          </prime-column>
          <prime-column field="toponimo" header="Toponimo"></prime-column>
          <prime-column field="indirizzo" header="Indirizzo"></prime-column>
          <prime-column field="civico" header="Civico"></prime-column>
          <prime-column field="cap" header="CAP"></prime-column>
          <prime-column field="comune" header="Comune" :sortable="true"></prime-column>
          <prime-column field="provincia" header="Provincia"></prime-column>
          <prime-column field="email" header="Email"></prime-column>
          <prime-column field="pec" header="PEC"></prime-column>
          <prime-column field="fax" header="Fax"></prime-column>
          <prime-column field="tel" header="Telefono"></prime-column>
          <prime-column field="cell" header="Cellulare"></prime-column>
          <prime-column header="Associazioni" :exportable="false" style="width: 7rem" bodyStyle="text-align:center">
            <template #body="{ data }">
              <prime-button
                v-if="hasContactAssociations(data)"
                icon="pi pi-eye"
                class="p-button-rounded p-button-info"
                v-tooltip.top="`Contratti: ${data.numero_contratti ?? data.contratti?.length ?? 0} · Caricamenti: ${data.numero_caricamenti ?? data.caricamenti?.length ?? 0}`"
                aria-label="Mostra contratti e caricamenti associati"
                @click.stop="openContactAssociations(data)"
              />
            </template>
          </prime-column>
          <prime-column field="numero_contratti_attivi" header="Contratti attivi" style="width: 7rem" bodyStyle="text-align:center">
            <template #body="{ data }">{{ data.numero_contratti_attivi ?? 0 }}</template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Documentazione">
      <AccordionDocumentiNomina v-if="!isClienteDomestico" :available="cambioRappresentanteAvailable" :client-id="data.item.id" />
      <prime-accordion>
        <prime-accordion-tab header="Aggiungi un nuovo file">
          <div class="formgrid grid form-documents">
            <div class="field col-12 md:col-3">
              <div class="button-wrapper">
                <span class="label">{{
                  data.allegato.file.length == 0
                    ? "Seleziona File"
                    : data.allegato.file.length == 1
                    ? data.allegato.file[0].name
                    : data.allegato.file.length + " files"
                }}</span>
                <input
                  id="upload"
                  type="file"
                  @change="handleFileUpload($event)"
                  accept="application/pdf,image/gif, image/jpeg, image/jpg,image/png"
                  multiple
                />
              </div>
              <div v-show="validationErrors.files && submitted" class="p-error">
                Campo richiesto.
              </div>
              <div v-show="validationErrors.type && submitted" class="p-error">
                Formato non consentito
              </div>
            </div>
            <div class="field col-12 md:col-3">
              <prime-dropdown
                class="inputfield w-full"
                v-model="data.allegato.tipo"
                :options="data.tipiAllegato"
                optionLabel="name"
                optionValue="id"
                placeholder="Seleziona tipologia..."
              />
              <div v-show="validationErrors.tipo && submitted" class="p-error">
                Campo richiesto.
              </div>
            </div>
            <div class="field col-12 md:col-3">
              <prime-textarea
                class="inputfield w-full"
                v-model="data.allegato.note"
                rows="1"
                placeholder="Inserisci note..."
              />
            </div>
            <div class="field col-12 md:col-3">
              <prime-button
                @click="uploadDocumenti"
                class="w-full"
                label="Carica"
                icon="pi pi-upload"
                iconPos="right"
              />
            </div>
          </div>
        </prime-accordion-tab>

        <prime-accordion-tab
          header="File Caricati"
          v-if="data.item.allegati && data.item.allegati.length > 0"
        >
          <prime-data-table
            :value="data.item.allegati"
            responsiveLayout="scroll"
          >
            <prime-column field="name" header="File" :sortable="true">
              <template #body="{ data }">
                <div v-if="data.name">
                  {{ data.name.split("/").reverse()[0] }}
                </div>
              </template>
            </prime-column>
            <prime-column
              field="tipo"
              header="Tipo"
              :sortable="true"
            ></prime-column>
            <prime-column
              field="date_creation"
              header="Data Caricamento"
              :sortable="true"
            ></prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <Button
                  icon="pi pi-download"
                  class="p-button-rounded p-button-success mr-2"
                  @click="downloadDocumenti(data)"
                />
              </template>
            </prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <Button
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-success mr-2"
                  @click="openDocumenti(data)"
                />
              </template>
            </prime-column>
          </prime-data-table>
        </prime-accordion-tab>

        <prime-accordion-tab v-for="(caricamento, index) in data.item.allegati_wizard" :key="index">
          <template #header>
            <div class="flex">
              File da wizard - caricamento #{{ caricamento[0].matrice_id }} -
              Pdp: {{ caricamento[0].pdp }}
            </div>
          </template>
          <prime-data-table :value="caricamento" responsiveLayout="scroll">
            <prime-column field="filename" header="File" :sortable="true" />
            <prime-column
              field="name"
              header="Tipo"
              :sortable="true"
            ></prime-column>
            <prime-column
              field="data_creazione"
              header="Data Caricamento"
              :sortable="true"
            >
              <template #body="{ data }">
                {{ moment(data.data_creazione).format("DD-MM-Y H:m:s") }}
              </template>
            </prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <Button
                  icon="pi pi-download"
                  class="p-button-rounded p-button-success mr-2"
                  @click="
                    downloadDocumento_wizard(data.matrice_id, data.filename)
                  "
                />
              </template>
            </prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <Button
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-success mr-2"
                  @click="openDocumento_wizard(data.matrice_id, data.filename)"
                />
              </template>
            </prime-column>
          </prime-data-table>
        </prime-accordion-tab>

        <prime-accordion-tab
          header="Documenti scansionati"
          v-if="data.item.scansioni && data.item.scansioni.length > 0"
        >
          <prime-data-table
            :value="data.item.scansioni"
            responsiveLayout="scroll"
          >
            <prime-column
              field="file"
              header="File"
              :sortable="true"
            ></prime-column>
            <prime-column
              field="mese"
              header="Mese"
              :sortable="true"
            ></prime-column>
            <prime-column
              field="anno"
              header="Anno"
              :sortable="true"
            ></prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <Button
                  icon="pi pi-download"
                  class="p-button-rounded p-button-success mr-2"
                  @click="downloadScansioni(data)"
                />
              </template>
            </prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <Button
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-success mr-2"
                  @click="openScansioni(data)"
                />
              </template>
            </prime-column>
          </prime-data-table>
        </prime-accordion-tab>
      </prime-accordion>
    </prime-accordion-tab>

    <prime-accordion-tab header="Contratti">
      <prime-data-table :value="data.item.contratti" responsiveLayout="scroll">
        <prime-column
          field="code"
          header="Identidicativo"
          :sortable="true"
        ></prime-column>
        <prime-column field="data_inizio" header="Inizio">
          <template #body="{ data }">
            {{
              data.data_inizio !== null
                ? moment(data.data_inizio).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column field="data_fine" header="Fine">
          <template #body="{ data }">
            {{
              data.data_fine !== null
                ? moment(data.data_fine).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column
          field="offerta"
          header="Offerta"
          :sortable="true"
        ></prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab header="Forniture Energia">
      <prime-data-table :value="data.item.pods" responsiveLayout="scroll">
        <prime-column field="code" header="POD" :sortable="true"></prime-column>
        <prime-column field="data_inizio" header="Inizio">
          <template #body="{ data }">
            {{
              data.data_inizio !== null
                ? moment(data.data_inizio).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column field="data_fine" header="Fine">
          <template #body="{ data }">
            {{
              data.data_fine !== null
                ? moment(data.data_fine).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column
          field="indirizzo_completo"
          header="Indirizzo"
        ></prime-column>
        <prime-column
          field="comune"
          header="Comune"
          :sortable="true"
        ></prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab header="Forniture Gas">
      <prime-data-table :value="data.item.pdrs" responsiveLayout="scroll">
        <prime-column field="code" header="PDR" :sortable="true"></prime-column>
        <prime-column field="data_inizio" header="Inizio">
          <template #body="{ data }">
            {{
              data.data_inizio !== null
                ? moment(data.data_inizio).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column field="data_fine" header="Fine">
          <template #body="{ data }">
            {{
              data.data_fine !== null
                ? moment(data.data_fine).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column
          field="indirizzo_completo"
          header="Indirizzo"
        ></prime-column>
        <prime-column
          field="comune"
          header="Comune"
          :sortable="true"
        ></prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span
          >Estratto Conto ({{
            currencyFormatter.format(
              data.item.saldo.saldo !== null ? data.item.saldo.saldo : 0
            )
          }})</span
        >
      </template>

      <prime-data-table
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        :value="data.item.fatture"
        responsiveLayout="scroll"
      >
        <prime-column field="data_emissione" header="Data" :sortable="true">
          <template #body="{ data }">
            {{
              data.data_emissione !== null
                ? moment(data.data_emissione).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column field="numero_fattura" header="Numero"></prime-column>
        <prime-column field="dare" header="Importo Fattura">
          <template #body="{ data }">
            {{ currencyFormatter.format(data.dare !== null ? data.dare : 0) }}
          </template>
        </prime-column>
        <prime-column field="avere" header="Importo Pagato">
          <template #body="{ data }">
            {{ currencyFormatter.format(data.avare !== null ? data.avere : 0) }}
          </template>
        </prime-column>
        <prime-column
          field="data_invio"
          header="Data Invio Preavviso"
          :sortable="true"
        >
          <template #body="{ data }">
            {{
              data.data_invio !== null
                ? moment(data.data_invio).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab header="Valutazione Cerved">
      <div class="flex justify-content-between">
        <!-- <div class="m-2 flex align-items-center justify-content-center">
          <Button
            v-if="!data.item.info.loaded_credit_check"
            @click="callCreditCheck(data.item.id)"
            >Vedi affidabilità</Button
          >
          <Button v-else @click="callCreditCheck(data.item.id, true)"
            >Aggiorna affidabilità</Button
          >
        </div> -->

        <div
          class="m-2 card"
          v-if="data.item.info.loaded_credit_check"
          style="width: fit-content"
        >
          <div v-if="data.item.info.has_credit_check" class="flex flex-wrap">
            <div class="col-12 flex justify-content-around align-items-center">
              <Button
                :class="[
                  `p-button-rounded m-2 p-button-${getLight(
                    data.item.info.credit_check_response.trafficLight
                  )}`,
                ]"
                style="opacity: 1"
                disabled
                >{{
                  data.item.info.credit_check_response.classDescription
                }}</Button
              >
              <div>
                <label>Score:</label>
                <p>
                  <strong style="font-size: 2.5rem">{{
                    data.item.info.credit_check_response.score
                  }}</strong
                  ><span>/100</span>
                </p>
              </div>
            </div>
            <div class="w-full flex justify-content-center col-12">
              <label class="mr-1">Aggiornato al:</label>
              <p>
                {{
                  moment(
                    data.item.info.credit_check_response.created_at
                  ).format("DD-MM-Y")
                }}
                ore
                {{
                  moment(
                    data.item.info.credit_check_response.created_at
                  ).format("H:m")
                }}
              </p>
            </div>
          </div>
          <div v-else>
            {{ data.item.info.credit_check_response.errorDescription }}
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Preavvisi Inviati">
      <prime-data-table
        :value="data.item.preavvisi"
        responsiveLayout="scroll"
        v-if="data.item.preavvisi && data.item.preavvisi.length > 0"
      >
        <prime-column
          field="numero_fattura"
          header="Numero Fattura"
          :sortable="true"
        ></prime-column>
        <prime-column
          field="data_invio"
          header="Data Invio"
          :sortable="true"
        >
          <template #body="{ data }">
            {{ moment(data.data_invio).format("YYYY/MM/DD") }}
          </template>
        </prime-column>
      </prime-data-table>
      <div v-else class="text-center p-4">
        Nessun preavviso trovato
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Storni Inviati">
      <prime-data-table
        :value="data.item.storni"
        responsiveLayout="scroll"
        v-if="data.item.storni && data.item.storni.length > 0"
      >
        <prime-column
          field="numero_fattura"
          header="Numero Fattura"
          :sortable="true"
        ></prime-column>
        <prime-column
          field="data_invio"
          header="Data Invio"
          :sortable="true"
        >
          <template #body="{ data }">
            {{ moment(data.data_invio).format("YYYY/MM/DD") }}
          </template>
        </prime-column>
      </prime-data-table>
      <div v-else class="text-center p-4">
        Nessuno storno trovato
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Provvigioni">
      <div v-if="data.item.id">
        <div class="formgrid grid mb-4">
          <div class="field col-12 md:col-6">
            <label for="anno">Anno</label>
            <Dropdown 
              v-model="selectedAnno" 
              :options="anniDisponibili" 
              optionLabel="name" 
              optionValue="value" 
              placeholder="Seleziona anno" 
              class="w-full"
            />
          </div>
        </div>

        <div v-if="selectedAnno" class="mt-4">
          <RiepilogoProvvigioniClienti 
            :id-cliente="data.item.id"
            :cliente-name="nomeCompletoCliente"
            :anno-selezionato="selectedAnno"
            :auto-search="true"
          />
        </div>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <div v-if="data.item.id" class="mt-3">
    <IncallTicketsBlock
      :entity-id="data.item.id"
      entity-type="client"
      :contact="ticketContact"
    />
  </div>

  <!-- Vecchia conferma del cambio rappresentante dall'anagrafica: la modifica ora avviene nella procedura dedicata.
  <prime-dialog
    v-model:visible="rappresentanteDialog.visible"
    header="Impostare il privilegiato"
    :modal="true"
    :dismissableMask="false"
    :style="{ width: '30rem' }"
  >
    <div class="mb-3">
      {{ rappresentanteDialog.data.message }}
    </div>
    <div v-if="rappresentanteDialog.data.hasClientsNotificaPreavvisi" class="mb-3">
      <p>
        Esistono altri clienti associati a questo rappresentante
        <span v-if="rappresentanteDialog.data.hasPrivilegedClients">
          (con un cliente già privilegiato).
        </span>
      </p>
    </div>

    <template #footer>
      <prime-button label="No" class="p-button-text" @click="onRappresentanteDialogNo" />
      <prime-button label="Sì, imposta privilegiato" class="p-button-primary" @click="onRappresentanteDialogYes" />
    </template>
  </prime-dialog>
  -->

</template>

<script>
import province from "@/data/province.json";

import ClientiService from "@/services/ask-management/clienti-service";
import AccordionDocumentiNomina from "@/components/ask/details/AccordionDocumentiNomina.vue";
import CambioRappresentanteService from "@/services/ask-pratiche/cambio-rappresentante";
import UtilityService from "@/services/ask-management/utility-service";

import Loader from "@/components/Loader.vue";
import PrimeButton from "primevue/button";
import PrimeInputText from "primevue/inputtext";
import PrimeTextarea from "primevue/textarea";
import PrimeDropdown from "primevue/dropdown";
import PrimeAccordion from "primevue/accordion";
import PrimeAccordionTab from "primevue/accordiontab";
import PrimeDataTable from "primevue/datatable";
import PrimeColumn from "primevue/column";
// import PrimeDialog from "primevue/dialog"; // Vecchia conferma del cambio rappresentante.
import Dropdown from "primevue/dropdown";
import RiepilogoProvvigioniClienti from "@/components/pratiche/RiepilogoProvvigioniClienti.vue";
import IncallTicketsBlock from "@/components/incall/IncallTicketsBlock.vue";
import SupplyRiepilogoSection from "@/components/ask/details/SupplyRiepilogoSection.vue";
import ImpersonateButton from '@/components/ask/details/ImpersonateButton.vue'
import ContactImpactDialog from "@/components/ask/details/ContactImpactDialog.vue";
import StoricoCambioAnagrafica from "@/components/ask/details/StoricoCambioAnagrafica.vue";

import moment from "moment";

export default {
  name: "ViewAskClientiDetail",
  components: {
    AccordionDocumentiNomina,
    PrimeButton,
    PrimeInputText,
    PrimeTextarea,
    PrimeDropdown,
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeDataTable,
    PrimeColumn,
    // PrimeDialog,
    Dropdown,
    RiepilogoProvvigioniClienti,
    IncallTicketsBlock,
    SupplyRiepilogoSection,
    ImpersonateButton,
    ContactImpactDialog,
    StoricoCambioAnagrafica,
    Loader,
  },

  data() {
    return {
      moment,
      loader: false,
      cambioRappresentanteAvailable: false,
      storicoCambiRappresentante: [],
      storicoCambiRappresentanteLoading: false,
      storicoCambiRappresentanteError: '',
      storicoCambiRappresentanteLoadedId: null,
      activeAccordionTabs: [0],
      validationErrors: {},
      submitted: false,

      currencyFormatter: new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }),

      route: {
        params: null,
      },

      isInEdit: false,
      oldInfo: null,

      data: {
        allegato: {
          allowedType: ["pdf", "jpeg", "jpg", "png"],
          file: [],
          tipo: null,
          note: null,
        },

        codiciIva: [],
        comuni: [],
        comuniFlat: [],
        tipiAllegato: [],
        tipiCliente: [],
        tipiCategoriaCliente: [],

        item: {
          info: {
            has_credit_check: false,
            loaded_credit_check: false,
          },
          preavvisi: [],
          storni: [],
          ticket: [],
        },
      },

      lights: [
        { check: "RED", color: "danger" },
        { check: "YELLOW", color: "warning" },
        { check: "GREEN", color: "success" },
      ],

      sospendibilePreavvisabilePermesso: false,
      comuniFiltered: [],
      comuneInput: null,
      ticketDialog: {
        visible: false,
        ticket: null,
      },
      // Vecchia conferma del cambio rappresentante dall'anagrafica.
      // rappresentanteDialog: {
      //   visible: false,
      //   data: { message: "", hasClientsNotificaPreavvisi: false, hasPrivilegedClients: false },
      // },
      // pendingUpdateInfo: null,
      // rappresentanteChangedInEdit: false,

      contactDialog: {
        visible: false,
        header: "Contratti e caricamenti associati",
        message: "",
        changes: [],
        contact: {},
        contractsHeader: "Contratti",
        confirmable: false,
        pendingContact: null,
      },
      contactRows: [],
      contactComuni: [],
      contactToponimi: [],
      editingContactRows: [],
      isContactRowEditing: false,
      duplicateContactIds: [],
      duplicateContactClearTimer: null,
      editingContactIndex: null,
      editingContactOriginal: null,

      selectedAnno: null,
      anniDisponibili: []
    };
  },

  created() {
    this.route.params = this.$route.params;
    // console.log(this.route.params)

    this.clientiService = new ClientiService(this.$http, this.$eventBus);
    this.loadCambioRappresentanteAvailability();
    this.getDettaglioCliente(this.route.params.id);

    this.utilityService = new UtilityService(this.$http, this.$eventBus);
    this.getCodiciIva();
    this.getComuni();
    this.getContactComuni();
    this.getContactToponimi();
    this.getTipiAllegato();
    this.getTipiCliente();
    this.getTipiCategoriaCliente();
    this.canUserChangeSospendibilePreavvisabile();
    this.getAnniDisponibili();
  },

  beforeUnmount() {
    this.clearDuplicateContactHighlightTimer();
  },

  methods: {
    async loadStoricoCambiRappresentante() {
      const id = this.data.item.id;
      if (!id || this.isClienteDomestico || this.storicoCambiRappresentanteLoadedId === id || this.storicoCambiRappresentanteLoading) return;
      this.storicoCambiRappresentanteLoading = true;
      this.storicoCambiRappresentanteError = '';
      try {
        this.storicoCambiRappresentante = await new CambioRappresentanteService(this.$http).storicoCambiRappresentante(id);
        this.storicoCambiRappresentanteLoadedId = id;
      } catch (error) {
        this.storicoCambiRappresentanteError = 'Impossibile caricare lo storico dei cambi rappresentante.';
      } finally {
        this.storicoCambiRappresentanteLoading = false;
      }
    },
    async loadCambioRappresentanteAvailability() {
      try {
        this.cambioRappresentanteAvailable = await new CambioRappresentanteService(this.$http).isAvailable();
      } catch (error) {
        this.cambioRappresentanteAvailable = false;
      }
    },
    hasContactAssociations(contact) {
      return Boolean(contact?.contratti?.length || contact?.caricamenti?.length);
    },

    openContactAssociations(contact) {
      this.contactDialog = {
        visible: true,
        header: "Contratti e caricamenti associati",
        message: "",
        changes: [],
        contact,
        contractsHeader: "Contratti",
        confirmable: false,
        pendingContact: null,
      };
    },

    getContactComuni() {
      return this.utilityService.getComuniConCap().then((res) => {
        this.contactComuni = res.items || [];
        this.prepareContactRows();
      });
    },

    getContactToponimi() {
      return this.utilityService.getToponimi().then((res) => {
        this.contactToponimi = res.items || [];
        this.prepareContactRows();
      });
    },

    contactSourceRows() {
      const contacts = this.data.item.info?.contatti;
      return Array.isArray(contacts) ? contacts : [];
    },

    prepareContactRows() {
      const contacts = this.contactSourceRows().map((contact) => ({
        ...contact,
        indirizzo_completo: [contact.toponimo, contact.indirizzo, contact.civico].filter(Boolean).join(" "),
      }));
      if (!this.isClienteDomestico) {
        this.contactRows = contacts;
        return;
      }
      if (!this.contactComuni.length || !this.contactToponimi.length) {
        this.contactRows = contacts;
        return;
      }

      const processedContacts = [];
      this.contactRows = contacts.map((contact) => {
        const validationErrors = this.getContactValidationErrors(contact);
        const parent = processedContacts.find((existing) => this.areContactsDuplicate(existing, contact));
        const preparedContact = {
          ...contact,
          invalid_fields: Object.keys(validationErrors),
          validation_errors: validationErrors,
          duplicate_of: parent?.id ?? null,
        };
        processedContacts.push(preparedContact);
        return preparedContact;
      });
    },

    normalizeContactText(value) {
      return String(value ?? "").normalize("NFKC").trim().replace(/\s+/g, " ").toLocaleUpperCase("it-IT");
    },

    normalizeContactEmail(value) {
      return String(value ?? "").normalize("NFKC").trim().replace(/\s+/g, " ").toLocaleLowerCase("it-IT");
    },

    normalizeContactPhone(value) {
      return String(value ?? "").replace(/[_\s-]/g, "");
    },

    hasContactValue(value) {
      return value !== null && value !== undefined && String(value).trim() !== "";
    },

    isValidContactEmail(value) {
      const email = String(value || "").trim();
      const parts = email.split("@");
      if (parts.length !== 2) return false;
      const [localPart, domain] = parts;
      if (!localPart || !domain || localPart.startsWith(".") || localPart.endsWith(".") || localPart.includes("..")) return false;
      if (!/^[A-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(localPart)) return false;
      const domainParts = domain.split(".");
      if (domainParts.length < 2 || domainParts.some((part) => !part)) return false;
      if (!domainParts.slice(0, -1).every((part) => /^[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?$/i.test(part))) return false;
      return /^[A-Z]{2,63}$/i.test(domainParts[domainParts.length - 1]);
    },

    isValidContactPec(value) {
      const pec = String(value || "").trim();
      if (!this.isValidContactEmail(pec)) return false;
      return !["example", "invalid", "localhost", "local", "test"].includes(pec.split(".").pop().toLowerCase());
    },

    isValidContactMobile(value) {
      const rawMobile = String(value || "").trim();
      if (/[^\d\s_-]/.test(rawMobile)) return false;
      const mobile = rawMobile.replace(/\D/g, "");
      return /^3\d{8,9}$/.test(mobile)
        && !/(\d)\1{4}/.test(mobile)
        && !/^(\d)\1+$/.test(mobile)
        && !/^3(\d)\1+$/.test(mobile)
        && !["3123456789", "3234567890", "3987654321", "3098765432"].includes(mobile);
    },

    findContactComune(contact) {
      const comuneId = contact.cod_comune ?? contact.comune;
      const byId = this.contactComuni.find((comune) => String(comune.id) === String(comuneId));
      if (byId) return byId;
      const comuneName = this.normalizeContactText(contact.nome_comune || contact.comune);
      const provincia = this.normalizeContactText(contact.provincia);
      return this.contactComuni.find((comune) => this.normalizeContactText(comune.name) === comuneName
        && this.normalizeContactText(comune.provincia) === provincia) || null;
    },

    isContactCapValid(cap, comune) {
      const value = this.normalizeContactText(cap);
      const comuneCap = this.normalizeContactText(comune?.cap);
      if (!/^\d{5}$/.test(value)) return false;
      if (/^\d{3}XX$/.test(comuneCap)) return value.startsWith(comuneCap.slice(0, 3));
      return /^\d{5}$/.test(comuneCap) && value === comuneCap;
    },

    contactCapSettings(contact) {
      const comune = this.findContactComune(contact);
      const cap = this.normalizeContactText(comune?.cap);
      const isWildcard = /^\d{3}XX$/.test(cap);
      const isFixed = /^\d{5}$/.test(cap);
      return { comune, isWildcard, isFixed, prefix: isWildcard ? cap.slice(0, 3) : "", initialValue: isWildcard ? cap.slice(0, 3) : (isFixed ? cap : "") };
    },

    prepareContactCapForEdit(contact) {
      const settings = this.contactCapSettings(contact);
      if (settings.comune && !this.isContactCapValid(contact.cap, settings.comune)) contact.cap = settings.initialValue;
    },

    contactCapSuffix(contact) {
      const prefix = this.contactCapSettings(contact).prefix;
      const cap = String(contact.cap || "");
      return cap.startsWith(prefix) ? cap.slice(prefix.length, prefix.length + 2) : "";
    },

    updateMultiCapSuffix(contact, value) {
      const prefix = this.contactCapSettings(contact).prefix;
      contact.cap = `${prefix}${String(value || "").replace(/\D/g, "").slice(0, 2)}`;
    },

    onChangeComuneContact(event, contact) {
      const comune = this.contactComuni.find((item) => String(item.id) === String(event.value));
      if (!comune) return;
      contact.cod_comune = comune.id;
      contact.comune = comune.name;
      contact.provincia = comune.provincia;
      contact.cap = this.contactCapSettings(contact).initialValue;
    },

    getContactValidationErrors(contact) {
      const errors = {};
      const comune = this.findContactComune(contact);
      const toponimo = this.normalizeContactText(contact.toponimo);
      if (!toponimo || !this.contactToponimi.some((item) => this.normalizeContactText(item.name) === toponimo)) errors.toponimo = "Il toponimo è obbligatorio e deve essere uno dei valori previsti.";
      if (!this.hasContactValue(contact.indirizzo)) errors.indirizzo = "L’indirizzo è obbligatorio.";
      if (!this.hasContactValue(contact.civico)) errors.civico = "Il civico è obbligatorio.";
      if (!comune) errors.comune = "Il comune è obbligatorio e deve essere valido.";
      if (!this.isContactCapValid(contact.cap, comune)) errors.cap = "Il CAP non è valido per il comune selezionato.";
      if (!comune || this.normalizeContactText(contact.provincia) !== this.normalizeContactText(comune.provincia)) errors.provincia = "La provincia deve coincidere con quella del comune.";
      if (!this.isValidContactEmail(contact.email)) errors.email = "L’email è obbligatoria e deve avere un formato valido.";
      const pecPresent = this.hasContactValue(contact.pec);
      if ((this.isClienteDomestico && pecPresent && !this.isValidContactPec(contact.pec))
        || (!this.isClienteDomestico && !this.isValidContactPec(contact.pec))) {
        errors.pec = this.isClienteDomestico
          ? "La PEC, se presente, deve avere un formato valido."
          : "La PEC è obbligatoria e deve avere un formato valido.";
      }
      if (!this.isValidContactMobile(contact.cellulare || contact.cell)) errors.cell = "Il cellulare deve iniziare con 3, contenere 9 o 10 cifre e rispettare le regole sulle sequenze.";
      return errors;
    },

    contactFieldError(contact, field) {
      return contact.validation_errors?.[field] || "";
    },

    isContactRowSaveDisabled(contact) {
      return Object.keys(this.getContactValidationErrors(contact)).length > 0;
    },

    contactRowSaveDisabledTooltip(contact) {
      return Object.values(this.getContactValidationErrors(contact)).join(" · ");
    },

    contactComuneComparableValue(contact) {
      const comune = this.findContactComune(contact);
      return comune ? `id:${this.normalizeContactText(comune.id)}` : `name:${this.normalizeContactText(contact.nome_comune || contact.comune)}`;
    },

    contactComparableValues(contact) {
      return [
        this.normalizeContactText(contact.toponimo), this.normalizeContactText(contact.indirizzo),
        this.normalizeContactText(contact.civico), this.normalizeContactText(contact.cap),
        this.contactComuneComparableValue(contact), this.normalizeContactText(contact.provincia),
        this.normalizeContactPhone(contact.cellulare || contact.cell), this.normalizeContactEmail(contact.email),
        this.normalizeContactEmail(contact.pec), this.normalizeContactPhone(contact.telefono || contact.tel),
        this.normalizeContactPhone(contact.fax),
      ];
    },

    areContactsDuplicate(firstContact, secondContact) {
      const secondValues = this.contactComparableValues(secondContact);
      return this.contactComparableValues(firstContact).every((value, index) => value.localeCompare(secondValues[index], "it-IT", { sensitivity: "base" }) === 0);
    },

    findDuplicateContacts(contact, excludedId = null) {
      return this.contactRows.filter((existing) => String(existing.id) !== String(excludedId) && this.areContactsDuplicate(existing, contact));
    },

    contactRowClass(contact) {
      return { "invalid-contact-row": Boolean(contact.invalid_fields?.length), "duplicate-contact-row": this.isHighlightedDuplicate(contact) };
    },

    isHighlightedDuplicate(contact) {
      return this.duplicateContactIds.some((id) => String(id) === String(contact.id));
    },

    clearDuplicateContactHighlightTimer() {
      if (this.duplicateContactClearTimer) clearTimeout(this.duplicateContactClearTimer);
      this.duplicateContactClearTimer = null;
    },

    scheduleDuplicateContactHighlightRemoval() {
      this.clearDuplicateContactHighlightTimer();
      if (!this.duplicateContactIds.length) return;
      this.duplicateContactClearTimer = setTimeout(() => {
        this.duplicateContactIds = [];
        this.duplicateContactClearTimer = null;
      }, 5000);
    },

    contactAddress(contact) {
      return [[contact.toponimo, contact.indirizzo, contact.civico].filter(Boolean).join(" "), [contact.cap, contact.comune, contact.provincia].filter(Boolean).join(" ")].filter(Boolean).join(", ");
    },

    onContactRowEditInit(event) {
      this.clearDuplicateContactHighlightTimer();
      this.duplicateContactIds = [];
      this.isContactRowEditing = true;
      this.editingContactIndex = event.index;
      this.editingContactOriginal = { ...event.data };
      this.prepareContactCapForEdit(event.newData);
    },

    restoreContactRow(index, contact) {
      if (index != null && contact) this.contactRows.splice(index, 1, { ...contact });
    },

    onContactRowEditCancel(event) {
      this.restoreContactRow(event.index, this.editingContactOriginal);
      this.editingContactRows = [];
      this.isContactRowEditing = false;
    },

    formatContactChangeValue(value) {
      return value === null || value === undefined || value === "" ? "(vuoto)" : String(value);
    },

    getContactChanges(oldContact, newContact) {
      return [
        ["toponimo", "Toponimo"], ["indirizzo", "Indirizzo"], ["civico", "Civico"], ["cap", "CAP"],
        ["comune", "Comune"], ["provincia", "Provincia"], ["email", "Email"], ["pec", "PEC"],
        ["fax", "Fax"], ["tel", "Telefono"], ["cell", "Cellulare"],
      ].filter(([field]) => oldContact[field] !== newContact[field]).map(([field, label]) => ({ field, label, oldValue: this.formatContactChangeValue(oldContact[field]), newValue: this.formatContactChangeValue(newContact[field]) }));
    },

    showDuplicateContactDialog(duplicateContacts) {
      this.clearDuplicateContactHighlightTimer();
      this.duplicateContactIds = duplicateContacts.map((contact) => contact.id);
      this.$confirm.require({
        group: "client-contact-edit",
        header: "Contatto duplicato",
        message: `Non è possibile modificare il contatto: coincide con ${duplicateContacts.length === 1 ? "un contatto già presente" : `${duplicateContacts.length} contatti già presenti`}.`,
        duplicateContacts,
        changes: [],
        acceptLabel: "Ho capito",
        rejectClass: "hidden",
        accept: () => this.scheduleDuplicateContactHighlightRemoval(),
        onHide: () => this.scheduleDuplicateContactHighlightRemoval(),
      });
    },

    onContactRowEditSave(event) {
      this.isContactRowEditing = false;
      const oldContact = { ...(this.editingContactOriginal || event.data) };
      const newContact = { ...event.newData };
      const duplicateContacts = this.findDuplicateContacts(newContact, oldContact.id);
      const changes = this.getContactChanges(oldContact, newContact);
      this.restoreContactRow(event.index, oldContact);
      if (duplicateContacts.length) {
        this.showDuplicateContactDialog(duplicateContacts);
        return;
      }
      this.contactDialog = {
        visible: true,
        header: "Conferma modifica contatto",
        message: "Confermi la modifica del contatto? La modifica sarà applicata anche alle associazioni esistenti.",
        changes,
        contact: oldContact,
        contractsHeader: "Contratti interessati",
        confirmable: true,
        pendingContact: newContact,
      };
    },

    confirmContactImpact() {
      if (this.contactDialog.pendingContact) {
        this.updateContact(this.contactDialog.pendingContact);
      }
      this.contactDialog.pendingContact = null;
    },

    updateContact(contact) {
      this.loader = true;
      this.clientiService.updateContact(contact, contact.cod_rapp || this.rappresentante.id)
        .then((saved) => saved && this.getDettaglioCliente(this.data.item.id))
        .finally(() => { this.loader = false; });
    },

    openTicketDialog(ticket) {
      this.ticketDialog.ticket = ticket;
      this.ticketDialog.visible = true;
    },
    canUserChangeSospendibilePreavvisabile() {
      this.utilityService.canUserChangeSospendibilePreavvisabile().then((res) => {
        res ? this.sospendibilePreavvisabilePermesso = true : this.sospendibilePreavvisabilePermesso = false
        console.log(this.sospendibilePreavvisabilePermesso);
      });
    },

    getComuni() {
      this.utilityService.getComuni().then((res) => {
        const listProvince = province.reduce((arr, el) => {
          arr[el.sigla] = `${el.regione} - ${el.nome}`;

          return arr;
        }, []);

        const comuni = res.items.reduce((arr, el) => {
          arr[el.provincia] = arr[el.provincia] || [];

          arr[el.provincia].push({
            id: el.id,
            descrizione: `${el.name} (${el.provincia})`,
          });

          return arr;
        }, []);

        const listComuni = [];
        for (const sigla in comuni) {
          listComuni.push({
            provincia: listProvince[sigla],
            items: comuni[sigla],
          });
        }
        listComuni.sort((a, b) => a.provincia.localeCompare(b.provincia));

        listComuni.unshift({
          provincia: "",
          items: [
            {
              id: -1,
              descrizione: "Nessuno",
            },
          ],
        });

        this.data.comuni = listComuni;

        const flat = listComuni.reduce((acc, group) => {
          if (Array.isArray(group.items)) acc.push(...group.items);
          return acc;
        }, []);
        this.data.comuniFlat = flat;
        this.syncComuneInput();
      });
    },
    searchComuni(event) {
      const query = (event.query || "").toLowerCase();
      if (!query) {
        this.comuniFiltered = [];
        return;
      }
      this.comuniFiltered = this.data.comuniFlat.filter((c) =>
        String(c.descrizione).toLowerCase().includes(query)
      );
    },
    syncComuneInput() {
      const currentId = this.data.item?.info?.cod_comune;
      if (currentId == null) {
        this.comuneInput = null;
        return;
      }
      if (!Array.isArray(this.data.comuniFlat) || !this.data.comuniFlat.length) return;
      const found = this.data.comuniFlat.find((c) => c.id === currentId);
      this.comuneInput = found ? found.descrizione : null;
    },
    onSelectComune(event) {
      const item = event.value || null;
      if (item) {
        this.data.item.info.cod_comune = item.id;
        this.comuneInput = item.descrizione;
      } else {
        this.data.item.info.cod_comune = null;
        this.comuneInput = null;
      }
    },
    onClearComune() {
      this.data.item.info.cod_comune = null;
      this.comuneInput = null;
    },

    getDettaglioCliente(id) {
      this.loader = true;
      this.clientiService
        .getDettaglioCliente(id)
        .then((res) => {
          this.data.item = res.item;
          if (this.storicoCambiRappresentanteLoadedId === Number(id)) {
            this.storicoCambiRappresentanteLoadedId = null;
            this.loadStoricoCambiRappresentante();
          }
          this.data.item.info.notificaPreavvisi = this.data.item.info
            .notificaPreavvisi
            ? 1
            : 0;

          this.data.item.info.has_credit_check = false;
          this.data.item.info.loaded_credit_check = false;
          this.data.item.info.nascondiscaduto = Boolean(
            this.data.item.info.nascondiscaduto
          );
          this.data.item.info.nascondiScadutoAnnoPrecedente = Boolean(
            this.data.item.info.nascondiScadutoAnnoPrecedente
          );
          document.title = this.nomeCompletoCliente
            ? document.title + " - " + this.nomeCompletoCliente
            : document.title;
          this.getExistentCreditCheck();
          this.getPreavvisiInfo(id);
          this.getStorniInfo(id);
          this.syncComuneInput();
          this.prepareContactRows();
        })
        .finally(() => {
          this.loader = false;
        });
    },

    getCodiciIva() {
      this.utilityService.getCodiciIva().then((res) => {
        const codiciIva = res.items.map((el) => {
          return {
            id: el.id,
            descrizione: `${el.descrizione} Natura: ${el.natura} Limite euro: ${el.limiteeuro}`,
          };
        });

        codiciIva.unshift({
          id: -1,
          descrizione: "Nessuno",
        });

        this.data.codiciIva = codiciIva;
      });
    },


    getTipiCliente() {
      this.utilityService.getTipiCliente().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiCliente = res.items;
      });
    },

    getTipiCategoriaCliente() {
      this.utilityService.getTipiCategoriaCliente().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiCategoriaCliente = res.items;
      });
    },

    getTipiAllegato() {
      this.utilityService.getTipiAllegato().then((res) => {
        this.data.tipiAllegato = res.items;
      });
    },

    downloadScansioni(item) {
      this.loader = true;
      this.utilityService.downloadScansioni(item).finally(() => {
        this.loader = false;
      });
    },

    openScansioni(item) {
      this.loader = true;
      this.utilityService.openScansioni(item).finally(() => {
        this.loader = false;
      });
    },

    downloadDocumenti(item) {
      this.loader = true;
      this.utilityService.downloadDocumenti(item).finally(() => {
        this.loader = false;
      });
    },

    openDocumenti(item) {
      this.loader = true;
      this.utilityService.openDocumenti(item).finally(() => {
        this.loader = false;
      });
    },
    handleFileUpload(event) {
      this.data.allegato.file = [];
      this.data.allegato.file = event.target.files;
    },
    uploadDocumenti() {
      this.submitted = true;
      if (this.validateToUpload()) {
        this.loader = true;
        let fd = new FormData();
        for (let i = 0; i < this.data.allegato.file.length; i++) {
          fd.append("files[]", this.data.allegato.file[i]);
        }
        fd.append("id", this.data.item.id);
        fd.append("obj", "client");
        fd.append("tipo", this.data.allegato.tipo);
        fd.append("note", this.data.allegato.note);

        this.utilityService
          .uploadDocumenti(fd)
          .then(() => {
            this.getDettaglioCliente(this.data.item.id);
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },
    validateToUpload() {
      this.validationErrors = {};

      if (!this.data.allegato.tipo) {
        this.validationErrors["tipo"] = true;
      } else {
        delete this.validationErrors["tipo"];
      }

      if (this.data.allegato.file.length == 0) {
        this.validationErrors["files"] = true;
      } else {
        delete this.validationErrors["files"];
      }

      if (this.data.allegato.file.length > 0) {
        let valid = [...this.data.allegato.file].every(
          (file) =>
            this.data.allegato.allowedType.includes(
              file.type.replace(/(.*)\//g, "")
            ),
          false
        );
        if (valid) delete this.validationErrors["type"];
        else this.validationErrors["type"] = true;
      }

      return !Object.keys(this.validationErrors).length;
    },

    onEditInfo() {
      this.oldInfo = JSON.stringify(this.data.item.info);

      this.isInEdit = !this.isInEdit;
    },

    onAbortInfoEdit() {
      this.data.item.info = JSON.parse(this.oldInfo);

      this.oldInfo = null;
      this.isInEdit = !this.isInEdit;
    },

    onUpdateInfo() {
      const allowed = [
        "ragsoc",
        "codfis",
        "piva",
        "toponimo",
        "indirizzo",
        "civico",
        "cap",
        "cod_comune",
        "ultimofatturato",
        "score",
        "pregiudizi",
        "cod_type_client",
        "cod_type_category_client",
        "note",
        "codiceDestinatario",
        "codiceAteco",
        "cod_codici_iva",
        "note_fattura",
        "nome",
        "cognome",
        "type_doc",
        "nascondiscaduto",
        "nascondiScadutoAnnoPrecedente",
        "email",
        "telefono",
        "cellulare"
      ];

      const info = Object.keys(this.data.item.info)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.data.item.info[key],
          };
        }, {});

      if (info.cod_comune == -1) {
        info.cod_comune = null;
      }
      if (
        typeof info.ultimofatturato == "string" &&
        info.ultimofatturato.trim() == ""
      ) {
        info.ultimofatturato = null;
      }
      if (typeof info.score == "string" && info.score.trim() == "") {
        info.score = null;
      }

      if (this.oldInfo != JSON.stringify(this.data.item.info)) {
        info.Sospeso = this.data.item.info.notificaPreavvisi ? 1 : 0;
        this.clientiService.updateInfo(this.data.item.id, info).then((res) => {
          if (res.success) {
            this.getDettaglioCliente(this.data.item.id);
            this.oldInfo = null;
            this.isInEdit = false;
          } else {
            console.error("Errore nell'aggiornamento dati cliente.");
          }
        });
      }
    },

    /* Vecchio flusso del cambio rappresentante dall'anagrafica, disattivato.
    onChangeRappresentante() {
      if (!this.isInEdit || !this.oldInfo) return;
      const originalInfo = JSON.parse(this.oldInfo);
      this.rappresentanteChangedInEdit =
        (originalInfo.cod_rapp ?? null) !== (this.data.item.info.cod_rapp ?? null);
    },

    onRappresentanteDialogYes() {
      this._finalizeUpdateWithSospeso(0);
    },

    onRappresentanteDialogNo() {
      this._finalizeUpdateWithSospeso(1);
    },

    _finalizeUpdateWithSospeso(sospesoValue) {
      if (!this.pendingUpdateInfo) {
        this.rappresentanteDialog.visible = false;
        return;
      }
      const info = { ...this.pendingUpdateInfo, Sospeso: sospesoValue };
      this.clientiService.updateInfo(this.data.item.id, info).then((res) => {
        if (res.success) this.getDettaglioCliente(this.data.item.id);
        this.pendingUpdateInfo = null;
        this.rappresentanteDialog.visible = false;
        this.oldInfo = null;
        this.isInEdit = false;
        this.rappresentanteChangedInEdit = false;
      });
    },
    */

    async getExistentCreditCheck() {
      let fd = new FormData();
      fd.append("id_cliente", this.route.params.id);
      let loaded_credit_check = false;
      let has_credit_check = false;

      await this.clientiService.existCallCreditCheck(fd).then((res) => {
        if (res.items.created_at) {
          this.data.item.info.credit_check_response = res.items;
          has_credit_check = true;
          loaded_credit_check = true;
        }
        this.data.item.info.has_credit_check = has_credit_check;
        this.data.item.info.loaded_credit_check = loaded_credit_check;
      });
    },

    async callCreditCheck(id_cliente, new_request = false) {
      this.loader = true;
      let fd = new FormData();
      fd.append("id_cliente", id_cliente);
      fd.append("new_request", JSON.stringify(new_request));

      await this.clientiService
        .callCreditCheck(fd)
        .then((res) => {
          this.data.item.info.credit_check_response = res.items;
          this.data.item.info.has_credit_check = res.items.code_status == 200;
          this.data.item.info.loaded_credit_check = true;
        })
        .finally(() => {
          this.loader = false;
        });
    },

    getLight(response_color) {
      let index = this.lights.findIndex(
        (light) => light.check == response_color
      );
      return this.lights[index].color;
    },
    openDocumento_wizard(id_matrice, filename) {
      this.loader = true;
      this.utilityService
        .viewDocumento_wizard(id_matrice, filename)
        .then((res) => {
          let pdfContents = res.item;
          pdfContents.forEach((pdf) => {
            const pdfContent = pdf[0];
            const pdfType = pdf[1];

            const decodedData = Uint8Array.from(atob(pdfContent), (c) =>
              c.charCodeAt(0)
            );
            const blob = new Blob([decodedData], { type: pdfType });
            const pdfUrl = URL.createObjectURL(blob);

            window.open(pdfUrl);
          });
        })
        .finally(() => {
          this.loader = false;
        });
    },
    downloadDocumento_wizard(id_matrice, filename) {
      this.loader = true;
      this.utilityService
        .downloadDocumento_wizard(id_matrice, filename)
        .finally(() => {
          this.loader = false;
        });
    },
    async getPreavvisiInfo(id) {
      this.loader = true;
      try {
        const response = await this.clientiService.getPreavvisiInfo(id);
        this.data.item.preavvisi = response.items;
      } catch (error) {
        console.error("Errore nel caricamento dei preavvisi:", error);
      } finally {
        this.loader = false;
      }
    },
    async getStorniInfo(id) {
      this.loader = true;
      try {
        const response = await this.clientiService.getStorniInfo(id);
        this.data.item.storni = response.items;
      } catch (error) {
        console.error("Errore nel caricamento degli storni:", error);
      } finally {
        this.loader = false;
      }
    },

    getStatusClass(statusCode) {
      switch (statusCode) {
        case 'opened':
          return 'color: #059669; font-weight: 600;';
        case 'in_progress':
          return 'color: #ea580c; font-weight: 600;';
        case 'closed':
          return 'color: #dc2626; font-weight: 600;'; 
        case 'canceled':
          return 'color: #2563eb; font-weight: 600;';
        default:
          return 'color: #6b7280;';
      }
    },

    async getAnniDisponibili() {
      const currentYear = new Date().getFullYear();
      this.anniDisponibili = [];
      for (let year = currentYear; year >= currentYear - 10; year--) {
        this.anniDisponibili.push({
          name: year.toString(),
          value: year
        });
      }
    }
  },

  computed: {
    isClienteDomestico() {
      const info = this.data.item.info || {};
      return Number(info.cod_type_client) === 2;
    },

    nomeCompletoCliente: function () {
      if (
        this.data.item.info.ragsoc &&
        this.data.item.info.ragsoc.trim() != ""
      ) {
        return this.data.item.info.ragsoc;
      }
      return `${this.data.item.info.nome} ${this.data.item.info.cognome}`;
    },

    ticketContact() {
      const info = this.data.item.info || {}
      return {
        id: this.data.item.id,
        client_id: this.data.item.id,
        entity_type: 'client',
        nome: info.nome,
        cognome: info.cognome,
        ragsoc: info.ragsoc,
        email: info.email,
        telefono: info.telefono || info.cellulare,
      }
    },

    clienteSaldoResiduo() {
      const saldo = Number(this.data.item?.saldo?.saldo ?? 0)
      return saldo > 0 ? saldo : 0
    },

    clienteSupplyPoints() {
      const pods = Array.isArray(this.data.item?.pods) ? this.data.item.pods : []
      const pdrs = Array.isArray(this.data.item?.pdrs) ? this.data.item.pdrs : []

      return [
        ...pods
          .filter((p) => p?.id)
          .map((p) => ({ id: p.id, type: 'pod', code: p.code || null })),
        ...pdrs
          .filter((p) => p?.id)
          .map((p) => ({ id: p.id, type: 'pdr', code: p.code || null })),
      ]
    },

    /**
     * Emails the client can use to access the area: the client's contacts plus
     * the representative. Same set that ask_api accepts server-side.
     */
    impersonationEmails: function () {
      const contatti = Array.isArray(this.data.item.info && this.data.item.info.contatti)
        ? this.data.item.info.contatti
        : []
      const emails = contatti.map((contatto) => contatto.email)
      emails.push(this.rappresentante.email)

      const unique = []
      emails.forEach((email) => {
        const value = typeof email === 'string' ? email.trim() : ''
        if (value !== '' && unique.indexOf(value) === -1) {
          unique.push(value)
        }
      })

      return unique
    },

    rappresentante: function () {
      let rappresentante = {
        id: null,
        name: null,
        codfis: null,
        email: null,
        pec: null,
        contatti: [],
      };

      if (
        this.data.item.rappresentanti &&
        this.data.item.rappresentanti.length !== 0
      ) {
        rappresentante = this.data.item.rappresentanti[0];
      }

      return rappresentante;
    },
  },
};
</script>

<style scoped>
.representative-summary-card {
  padding: 1rem;
  border: 1px solid var(--surface-border);
  border-radius: 8px;
  background: var(--surface-50);
}

.representative-summary-card h5 {
  margin: 0 0 1rem;
}

.representative-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.representative-summary-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.representative-summary-field span {
  color: var(--text-color-secondary);
  font-size: 0.8rem;
}

.representative-summary-field strong {
  overflow-wrap: anywhere;
}

.representative-summary-card + .representative-contacts-table {
  margin-top: 1rem;
}

.association-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.contract-chip-legend {
  display: block;
  margin-bottom: 0.75rem;
  color: var(--text-color-secondary);
}

.contract-chip-legend .pi {
  margin-right: 0.4rem;
}

.contract-chip-link {
  color: inherit;
  text-decoration: none;
}

.contract-chip-link :deep(.contract-chip-active) {
  background: #dcfce7;
  color: #166534;
}

.contract-chip-link :deep(.contract-chip-warning) {
  background: #fff1bd;
  color: #854d0e;
}

.contract-chip-link :deep(.contract-chip-inactive) {
  background: #fbe0e0;
  color: #991b1b;
}

.contract-chip-link :deep(.contract-chip-neutral) {
  background: #e9edf2;
  color: #475569;
}

.contact-edit-confirmation {
  width: 100%;
}

.duplicate-contacts-list {
  max-height: 20rem;
  overflow-y: auto;
}

.duplicate-contact-section {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #f59e0b;
  border-radius: 6px;
  background: #fffbeb;
  color: #78350f;
  line-height: 1.5;
}

.duplicate-contact-title,
.contact-field-cell {
  display: flex;
  align-items: center;
}

.duplicate-contact-title {
  gap: 0.6rem;
  margin-bottom: 0.5rem;
}

.duplicate-contact-dialog-hand,
.duplicate-contact-badge {
  display: inline-block;
  animation: client-contact-hand 0.9s ease-in-out infinite;
}

.duplicate-contact-dialog-hand,
.duplicate-contact-badge {
  font-size: 1.5rem;
}

.duplicate-contact-badge {
  margin-right: 0.5rem;
}

.contact-validation-icon {
  color: #dc2626;
  cursor: help;
}

.contact-id-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}

.contact-id-main {
  display: flex;
  align-items: center;
}

.contact-duplicate-label {
  display: inline-flex;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.multicap-editor {
  display: flex;
  align-items: stretch;
  min-width: 8rem;
}

.multicap-prefix {
  display: inline-flex;
  align-items: center;
  padding: 0 0.65rem;
  border: 1px solid var(--surface-border);
  border-right: 0;
  border-radius: 6px 0 0 6px;
  background: var(--surface-100);
  color: var(--text-color-secondary);
  font-weight: 600;
}

.multicap-suffix {
  width: 4rem;
  border-radius: 0 6px 6px 0;
}

.contact-changes-section {
  margin-top: 1.25rem;
  padding: 1rem;
  background: var(--surface-50);
  border: 1px solid var(--surface-border);
  border-radius: 6px;
}

.contact-changes-section h5 {
  margin: 0 0 0.75rem;
}

.contact-change-row + .contact-change-row {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--surface-border);
}

.contact-change-values {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
  margin-top: 0.35rem;
}

.contact-change-old {
  color: var(--text-color-secondary);
  text-decoration: line-through;
}

.contact-change-new {
  color: var(--primary-color);
  font-weight: 600;
}

:deep(.p-datatable-tbody > tr.invalid-contact-row > td),
:deep(.p-datatable-tbody > tr.invalid-contact-row:hover > td) {
  background: #fee2e2 !important;
  border-top-color: #ef4444 !important;
  border-bottom-color: #ef4444 !important;
}

:deep(.p-datatable-tbody > tr.invalid-contact-row > td:first-child) {
  border-left: 4px solid #dc2626 !important;
}

:deep(.duplicate-contact-row) {
  position: relative;
  z-index: 1;
  animation: client-contact-pulse 1.3s ease-in-out infinite;
}

:deep(.duplicate-contact-row > td) {
  background: #fffbeb !important;
  border-top-color: #f59e0b !important;
  border-bottom-color: #f59e0b !important;
}

@keyframes client-contact-hand {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(0.4rem); }
}

@keyframes client-contact-pulse {
  0%, 100% { filter: brightness(1); }
  50% { filter: brightness(0.94); }
}

@media (max-width: 991px) {
  .representative-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575px) {
  .representative-summary-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>

